﻿import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { LanguageService } from "../../../core/language/language.service";
import { OrganizationalUnitDropdownItem } from "../../../core/models/administration/global-codes/organizational-unit-dropdown-item";
import { SharedService } from "../../../shared/shared.service";
import { OrganizationalUnitQuestionsService } from "../../organizational-unit-questions/organizational-unit-questions.service";


export class ListByAnswerTime {
    id: number;
    questionsList: QuestionsModel[] = [];
}
export class QuestionsModel {
    id: number;
    answerTime: number;
    answerTimeFormatted: string;
}
export class NumberOfQuestionsAndAnswers {
    numberOfQuestions: number;
    numberOfAnswers: number;
}
export class NumberOfAnsweredAndNotAnsweredQuestions {
    id: number;
    name: string;
    numberOfQuestions: number;
    numberOfAnswered: number;
    numberOfNotAnswered: number;
}
export class NumberOfQuestionsByGender {
    sexId: number;
    sexName: string;
    number: number;
}
export class NumberOfQuestionsBySensitiveCategory {
    sensitiveCategoryId: number;
    sensitiveCategoryName: string;
    number: number;
}
export class NumberOfQuestionsByYearGroup {
    number: number;
    numberYear: number;
}
export class ListAverageAnswerTime {
    id: number;
    name: string;
    averageAnswerTime: number;
    averageAnswerTimeFormatted: string;
}
export class OrganizationalUnitModel {
    languageId: number;
    Id: number;
    questionDateTo: Date;
    questionDateFrom: Date;
}

@Component({
    selector: 'app-organizational-unit-questions-statistic',
    templateUrl: './organizational-unit-questions-statistic.component.html'
})

export class OrganizationalUnitQuestionsStatistic implements OnInit {
    @Output() numberOfQuestionsAnswersList: EventEmitter<NumberOfQuestionsAndAnswers> = new EventEmitter<NumberOfQuestionsAndAnswers>();
    @Output() listByAnswerTime: EventEmitter<ListByAnswerTime> = new EventEmitter<ListByAnswerTime>();
    @Output() numberOfQuestionsByGender: EventEmitter<NumberOfQuestionsByGender[]> = new EventEmitter<NumberOfQuestionsByGender[]>();
    @Output() numberOfQuestionsBySensitiveCategory: EventEmitter<NumberOfQuestionsBySensitiveCategory[]> = new EventEmitter<NumberOfQuestionsBySensitiveCategory[]>();
    @Output() numberOfQuestionsByYearGroup: EventEmitter<NumberOfQuestionsByYearGroup[]> = new EventEmitter<NumberOfQuestionsByYearGroup[]>();
    @Output() numberOfAnsweredAndNotAnsweredQuestions: EventEmitter<NumberOfAnsweredAndNotAnsweredQuestions[]> = new EventEmitter<NumberOfAnsweredAndNotAnsweredQuestions[]>();
    @Output() listAverageAnswerTime: EventEmitter<ListAverageAnswerTime[]> = new EventEmitter<ListAverageAnswerTime[]>();


    private languageID: number;
    public organizationalUnitModel: OrganizationalUnitModel;
    public organizationalUnits: OrganizationalUnitDropdownItem[] = [];

    private organizationalUnitsQuestionsAnswersList: NumberOfQuestionsAndAnswers;
    private organizationalUnitsByAnswerTime: ListByAnswerTime;
    private organizationalUnitNumberOfAnsweredAndNotAnsweredQuestions: NumberOfAnsweredAndNotAnsweredQuestions[] = []; 
    private organizationalUnitNumberOfQuestionsByGender: NumberOfQuestionsByGender[] = [];
    private organizationalUnitNumberOfQuestionsBySensitiveCategory: NumberOfQuestionsBySensitiveCategory[] = [];
    private organizationalUnitNumberOfQuestionsByYearGroup: NumberOfQuestionsByYearGroup[] = [];
    private organizationalUnitListAverageAnswerTime: ListAverageAnswerTime[] = [];



    constructor(private _organizationalUnitsService: OrganizationalUnitQuestionsService,
        private _languageService: LanguageService,
        private _sharedService: SharedService) {

        this.languageID = this._languageService.selectedLanguageId;
        this.organizationalUnitModel = new OrganizationalUnitModel();

    }
    
    ngOnInit() {
        this._organizationalUnitsService.getAllOrganizationalUnitsForDropdown(0, true, this.languageID).subscribe(result => {
            this.organizationalUnits = result;
            this.initOrganizationalUnitModel();
            this.getNumberOfCouncilOrganizationalUnits();
            this.getOrganizationalUnitListByAnswerTime();
            this.getNumberOfAnsweredAndNotAnswered();
            this.getNumberOfQuestionsByGender();
            this.getNumberOfQuestionsBySensitiveCategory();
            this.getMemberListAverageAnswerTime();
            this.getNumberOfQuestionsByYearGroup();
        });
    }
    initOrganizationalUnitModel() {
        this.organizationalUnitModel.languageId = this._languageService.selectedLanguageId;
        this.organizationalUnitModel.Id = 0;
        this.organizationalUnitModel.questionDateFrom = null;
        this.organizationalUnitModel.questionDateTo = null;
    }
    onOrganizationalUnitChange(id: number) {
        this.organizationalUnitModel.Id = id;
        this.getNumberOfCouncilOrganizationalUnits();
        this.getOrganizationalUnitListByAnswerTime();
        this.getNumberOfAnsweredAndNotAnswered();
        this.getNumberOfQuestionsByGender();
        this.getNumberOfQuestionsBySensitiveCategory();
        this.getMemberListAverageAnswerTime();
        this.getNumberOfQuestionsByYearGroup();
    }
    onQuestionDateFromChanged(date: Date) {
        this.organizationalUnitModel.questionDateFrom = date;
        this.getNumberOfCouncilOrganizationalUnits();
        this.getOrganizationalUnitListByAnswerTime();
        this.getNumberOfAnsweredAndNotAnswered();
        this.getNumberOfQuestionsByGender();
        this.getNumberOfQuestionsBySensitiveCategory();
        this.getMemberListAverageAnswerTime();
        this.getNumberOfQuestionsByYearGroup();



    }

    onQuestionDateToChanged(date: Date) {
        this.organizationalUnitModel.questionDateTo = date;
        this.getNumberOfCouncilOrganizationalUnits();
        this.getOrganizationalUnitListByAnswerTime();
        this.getNumberOfAnsweredAndNotAnswered();
        this.getNumberOfQuestionsByGender();
        this.getNumberOfQuestionsBySensitiveCategory();
        this.getMemberListAverageAnswerTime();
        this.getNumberOfQuestionsByYearGroup();
    }


    getNumberOfCouncilOrganizationalUnits() {
        this._organizationalUnitsService.GetNumberOfOrganizationalUnitQuestionsAndAnswers(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitsQuestionsAnswersList = result;
            this.numberOfQuestionsAnswersList.emit(this.organizationalUnitsQuestionsAnswersList);
        });
    }
    getOrganizationalUnitListByAnswerTime() {
        this._organizationalUnitsService.getOrganizationalUnitListByAnswerTime(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitsByAnswerTime = result;
            this.listByAnswerTime.emit(this.organizationalUnitsByAnswerTime);
        });
    }
    getNumberOfAnsweredAndNotAnswered() {
        this._organizationalUnitsService.getNumberOfAnsweredAndNotAnsweredQuestions(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitNumberOfAnsweredAndNotAnsweredQuestions = result;
            this.numberOfAnsweredAndNotAnsweredQuestions.emit(this.organizationalUnitNumberOfAnsweredAndNotAnsweredQuestions);
        });
    }
    getNumberOfQuestionsByGender() {
        this._organizationalUnitsService.getNumberOfQuestionsByGender(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitNumberOfQuestionsByGender = result;
            this.numberOfQuestionsByGender.emit(this.organizationalUnitNumberOfQuestionsByGender);
        });
    }
    getNumberOfQuestionsBySensitiveCategory() {
        this._organizationalUnitsService.getNumberOfQuestionsBySensitiveCategory(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitNumberOfQuestionsBySensitiveCategory = result;
            this.numberOfQuestionsBySensitiveCategory.emit(this.organizationalUnitNumberOfQuestionsBySensitiveCategory);
        });
    }
    getNumberOfQuestionsByYearGroup() {
        this._organizationalUnitsService.getNumberOfQuestionsByYearGroup(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitNumberOfQuestionsByYearGroup = result;
            this.numberOfQuestionsByYearGroup.emit(this.organizationalUnitNumberOfQuestionsByYearGroup);
        });
    }
    getMemberListAverageAnswerTime() {
        this._organizationalUnitsService.getOrganizationalUnitListAverageAnswerTime(this.organizationalUnitModel).subscribe(result => {
            this.organizationalUnitListAverageAnswerTime = result;
            this.listAverageAnswerTime.emit(this.organizationalUnitListAverageAnswerTime);
        });
    }
}